/*
 * File: form-string.ts
 * File Created: 2024-01-11 01:28:50
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:32:57
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiSubmitIgnore: true,
})
export default class FormHeader extends BaseFormComponent {}
